/* Cart acknowledgement only: Shopify still owns the delivery choice and payment. */
(() => {
  if (window.__olCollectionSafeguardBound) return;
  window.__olCollectionSafeguardBound = true;

  const acknowledgementSelector = '[data-ol-collection-ack]';
  const isCartForm = (form) => form && (form.id === 'cart' || form.id === 'CartDrawer-Form');

  function clearError(input) {
    input.removeAttribute('aria-invalid');
    const error = input.closest('[data-ol-collection-safeguard]')?.querySelector('[data-ol-collection-error]');
    if (error) error.hidden = true;
  }

  function showError(input) {
    input.setAttribute('aria-invalid', 'true');
    const error = input.closest('[data-ol-collection-safeguard]')?.querySelector('[data-ol-collection-error]');
    if (error) error.hidden = false;
    input.focus({ preventScroll: true });
    input.scrollIntoView({ block: 'center' });
  }

  function resetAcknowledgements() {
    document.querySelectorAll(acknowledgementSelector).forEach((input) => {
      input.checked = false;
      clearError(input);
    });
  }

  // Some storefront apps redirect from the checkout click without submitting
  // its form. Window capture runs before their document/element click handlers.
  window.addEventListener('click', (event) => {
    const button = event.target.closest?.('button[name="checkout"], input[name="checkout"]');
    const form = button?.form;
    if (!isCartForm(form)) return;
    const input = document.querySelector(`${acknowledgementSelector}[form="${form.id}"]`);
    if (!input || input.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(input);
  }, true);

  // Native required validation handles normal forms; submit covers novalidate
  // forms as well. Delegation survives Shopify's section HTML replacements.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isCartForm(form)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    const input = document.querySelector(`${acknowledgementSelector}[form="${form.id}"]`);
    if (!input || input.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(input);
  }, true);

  document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!input.matches?.(acknowledgementSelector)) return;
    event.preventDefault();
    showError(input);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input.matches?.(acknowledgementSelector)) {
      if (input.checked) clearError(input);
      return;
    }
    if (input.matches?.('input[name="updates[]"]') && input.closest('cart-items, cart-drawer-items')) {
      resetAcknowledgements();
    }
  }, true);

  // Browser history/form restoration must not pre-check a later visit. Cart
  // mutations also render new unchecked markup in both refreshed footers.
  window.addEventListener('pageshow', resetAcknowledgements);
  resetAcknowledgements();
})();
